export default "__VITE_ASSET__v5uN4FlS__"